module.exports = __webpack_public_path__ + "img/about_image1_small.b7072933.jpg";